import React from "react";
import { bool, func, string, shape } from "prop-types";
import FileDropzone from "../../common/FileDropzone/FileDropzone";
import * as style from "./styles.module.scss";
import { isMobile } from "../../helpers";

const documentsCodes = {
  JPA1: "Proof of Address",
  JPDL: "Driving Licence",
  JPBS: "Bank, Building Society or Credit Card Statement",
  JPBC: "Bank or Building Society Confirmation Letter",
  JPUT: "Utility Bill",
  JPHL: "Benefit or HMRC Statement",
  JPWP: "Local Government or Department for Working Pension Document",
  JPID: "Proof of ID (Front)",
  JIDB: "Proof of ID (Back)",
  JP45: "P45 or P60",
  JPMS: "Mortgage Statement",
  JPCT: "Council Tax",
  JPLL: "Landlord Letter",
  JNIP: "Proof of NI",
  JPMC: "Marriage Certificate",
  JPSP: "Internet Speed Capture",
  JNAC: "Change of Name",
  JUNI: "University Letter",
  JBUS: "Business Car Insurance",
  JQUA: "Qualifications & Certifications",
  JDB1: "DBS Certificate Page 1 (Front)",
  JDB2: "DBS Certificate Page 2 (Back)",
  JPG3: "DBS Related Document",
};

const getRecentDocumentMessage = (fileTypeCode) => {
  if (["JPBS", "JPBC", "JPUT"].indexOf(fileTypeCode) !== -1)
    return "Your document should be from within the last 3 months.";
  if (["JP45", "JPCT"].indexOf(fileTypeCode) !== -1)
    return "Your document should be from within the last 12 months.";
  if (["JPA1"].indexOf(fileTypeCode) !== -1)
    return "Your document should be from within the last 3 months, cannot be a mobile phone bill.";
  return null;
};

const DocumentationForm = ({
  state,
  handleChange,
  isUpdating,
  setType,
  isFileValid,
  handleInvalidType,
}) => {
  const recentDocumentMessage = getRecentDocumentMessage(state.fileTypeCode);
  const fileTypeHint = `Choose an image of your document.\nThis should be a JPEG or PNG file.`;
  const docCodes = { ...documentsCodes };

  return (
    <div className="mt-1 row">
      {isUpdating && (
        <h5 className="d-none d-lg-inline col-12">Add a new document</h5>
      )}
      <div className="form-group col-12 col-md-8 col-lg-6">
        <label>Document Type</label>
        <select
          className="form-control"
          id="fileTypeCode"
          onChange={(e) => {
            const selected = e.target.selectedOptions[0];
            setType(selected.text, selected.value);
          }}
          value={state.fileTypeCode}
        >
          <option value="">Select the type of document</option>
          {Object.keys(docCodes)
            .sort((a, b) => docCodes[a].localeCompare(docCodes[b]))
            .map((code) => (
              <option value={code} key={code}>
                {docCodes[code]}
              </option>
            ))}
        </select>
      </div>
      {((state.fileTypeCode !== "" && isMobile && state.documentFile) ||
        (state.fileTypeCode !== "" && !isMobile)) && (
        <div className="p-1 w-100">
          <FileDropzone
            fileTypeHint={fileTypeHint}
            additionalMessage={recentDocumentMessage}
            acceptedFileTypes={".jpg,.jpeg,.png"}
            handleChange={handleChange}
            fileStateName="documentFile"
            fileParsedToString={state.documentFile}
            isFileValid={isFileValid}
            handleInvalidType={handleInvalidType}
            wrongFileTypeHint={
              "Your document needs to be provided as a JPEG or PNG file."
            }
            dropFileMsg={`Drop your ${docCodes[state.fileTypeCode]} file here`}
            fileCategory={"document"}
            height={isUpdating ? "315px" : "400px"}
            width="100%"
          />
        </div>
      )}
      {!(state.documentFile || !isFileValid) && (
        <div className={style.documentation_form__blank}>
          <span className={style.documentation_form__hint}>
            {recentDocumentMessage}
          </span>
          <span className={style.documentation_form__hint}>{fileTypeHint}</span>
        </div>
      )}
    </div>
  );
};

DocumentationForm.propTypes = {
  isUpdating: bool,
  state: shape({
    documentFile: string,
    fileTypeCode: string,
  }),
  handleChange: func,
  setType: func,
  isFileValid: bool,
  handleInvalidType: func,
};

export default DocumentationForm;
